import axios from "axios";
import moment from "moment";
import {
  Container,
  Form,
  InputGroup,
  Table,
  Button,
  Modal,
  FormControl,
  Navbar,
  Nav,
} from "react-bootstrap";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faCheck } from "@fortawesome/free-solid-svg-icons";
import { read, utils } from 'xlsx';

import UserService from "../Common/UserService";
import PaginationList from "../Common/PaginationList";
import { plantOption, pageLimitOption } from "../Common/DropdownList";
import LoginPage from "./LoginPage";

export const styles = {
  NavbarStyle: { backgroundColor: "#1f4529" },
  TextStyle: { fontWeight: "bold", color: "#c2ffc7" },
};

const ResultPage = () => {
  const navigate = useNavigate();
  const [searchKeyword, setSearchKeyword] = useState("");
  const [site, setSite] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [limitPage, setLimitPage] = useState(30);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [showList, setShowList] = useState([]);
  const [id, setId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    const today = moment().format("YYYY-MM-DD");
    const oneWeekAgo = moment().subtract(7, "days").format("YYYY-MM-DD");

    setToDate(today);
    setFromDate(oneWeekAgo);
  }, []);

  const sv_name = localStorage.getItem("sv_name");
  const access_token = localStorage.getItem("access_token");

  const getList = async (page = 1) => {
    try {
      let res;
      if (searchKeyword) {
        const entity = {
          keyword: searchKeyword,
          page: page,
          limit: +limitPage,
        };
        // console.log(51, entity);
        res = await axios.post(
          `https://pyc99.hslnet.my/api/batching/search`,
          entity
        );
      } else {
        if (site) {
          if (site == 0) {
            res = await axios.get(
              `https://pyc99.hslnet.my/api/batching/get/all/${fromDate}/${toDate}/${page}/${limitPage}`
            );
          } else {
            res = await axios.get(
              `https://pyc99.hslnet.my/api/batching/get/${site}/${fromDate}/${toDate}/${page}/${limitPage}`
            );
          }
        } else {
          res = await axios.get(
            `https://pyc99.hslnet.my/api/batching/get/all/${fromDate}/${toDate}/${page}/${limitPage}`
          );
        }
      }
      // console.log(67, res);
      if (res.data?.data.length > 0) {
        setShowList(res?.data?.data);
        setTotalPage(res?.data?.totalPages);
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  const handleChangePlant = (event) => {
    const selectedValue = event.target.value;
    setSite(selectedValue);
    // Clear all lists and reset pagination when changing plant/site
    setShowList([]);
    setSelectedItems([]);
    setTotalPage(1);
    setCurrentPage(1);
    // Get new list for selected site
    getList();
  };

  const handleChangefromDate = (e) => {
    const newfromDate = e.target.value;
    setFromDate(newfromDate);
    // Clear all lists and reset pagination when changing date
    setShowList([]);
    setSelectedItems([]);
    setTotalPage(1);
    setCurrentPage(1);
    // Get new list for selected date range
    getList();
  };

  const handleChangetoDate = (e) => {
    const newtoDate = e.target.value;
    setToDate(newtoDate);
    // Clear all lists and reset pagination when changing date
    setShowList([]);
    setSelectedItems([]);
    setTotalPage(1);
    setCurrentPage(1);
    // Get new list for selected date range
    getList();
  };

  const handleClickSearch = () => {
    setShowList([]);
    setSelectedItems([]);
    setTotalPage(1);
    setCurrentPage(1);
    getList();
  };

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      handleClickSearch(event);
    }
  };

  const handleChangeLimitPage = (event) => {
    const selectedValue = event.target.value;
    setLimitPage(selectedValue);
    // Clear all lists and reset pagination when changing page limit
    setShowList([]);
    setSelectedItems([]);
    setTotalPage(1);
    setCurrentPage(1);
    // Get new list with updated page limit
    getList();
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
    getList(page);
  };

  const handleTick = (_id) => {
    setShowModal(true);
    setId(_id);
  };

  const handleNo = () => {
    setShowModal(false);
    setId("");
  };

  const handleYes = async () => {
    const entity = {
      id: id,
      review: 1,
      reviewed_by: sv_name,
    };
    try {
      await axios.put(
        "https://pyc99.hslnet.my/api/batching/update/review",
        entity
      );
      setShowModal(false);
      await getList();
    } catch (err) {
      console.error(err.message);
    }
  };

  const handleDownloadExcel = async () => {
    const entity = {
      site: site ? +site : 0,
      fromDate: fromDate,
      toDate: toDate,
      keyword: searchKeyword,
    };
    axios
      .post(`https://pyc99.hslnet.my/api/batching/export/excel2`, entity, {
        responseType: "blob",
      })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `batching_data_${fromDate}_to_${toDate}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        console.error("Error downloading file:", err);
      });
  };

  const handleLogout = () => {
    Swal.fire({
      title: "Confirm Logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        UserService.doLogout();
        navigate && navigate("/");
      }
    });
  };

  const handleCheckboxChange = (event, item) => {
    if (event.target.checked) {
      setSelectedItems([...selectedItems, item]);
    } else {
      setSelectedItems(selectedItems.filter((selected) => selected !== item));
    }
  };

  const handlePrint = async () => {
    try {
      const dataToSend = selectedItems.length > 0 ? selectedItems : showList;
      
      const response = await axios.post(
        'https://pyc99.hslnet.my/api/batching/export/generate-xls',
        { data: dataToSend, site },
        {
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'blob'
        }
      );

      // Create a blob from the response data
      const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      // Create a link element and trigger download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `batching_data_${moment().format('YYYYMMDD_HHmmss')}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Excel file has been generated successfully'
      });
    } catch (error) {
      console.error('Error generating Excel:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data || 'Failed to generate Excel file'
      });
    }
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Check if it's an Excel file
    if (!file.name.match(/\.(xlsx|xls)$/)) {
      Swal.fire({
        title: 'Error',
        text: 'Please upload an Excel file (.xlsx or .xls)',
        icon: 'error'
      });
      return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        // Read Excel data directly
        const workbook = read(e.target.result, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = utils.sheet_to_json(worksheet);

        // const jsonData = [
        //   { donumber: "SMR013862" },
        //   { donumber: "SMR013861" },
        // ];

        // Extract DO numbers and determine site based on prefix
        const doNumbers = jsonData.map(row => {
          const doNumber = row.donumber || row.do_no;
          
          if (!doNumber) return null;
          
          const doStr = String(doNumber).toUpperCase();
          let site = 3; // Default to Stephen Yong (3)
          
          if (doStr.startsWith('SMR')) {
            site = 4; // Samariang
          } else if (doStr.startsWith('MTB')) {
            site = 1; // Muara Tabuan
          } else if (doStr.startsWith('BPL')) {
            site = 2; // Paloh
          }
          
          return { doNumber, site };
        }).filter(Boolean);

        console.log('DO Numbers found:', doNumbers);

        if (doNumbers.length === 0) {
          setShowList([]);
          setSelectedItems([]);
          setTotalPage(1);
          setCurrentPage(1);
          
          Swal.fire({
            title: 'Error',
            text: 'No DO numbers found in the Excel file',
            icon: 'error'
          });
          return;
        }

        // Check if all DO numbers have the same site
        const uniqueSites = [...new Set(doNumbers.map(item => item.site))];
        if (uniqueSites.length === 1) {
          // If all DO numbers are from the same site, update the dropdown
          setSite(uniqueSites[0]);
        } else {
          // If DO numbers are from different sites, set to "All" (0)
          setSite(0);
          Swal.fire({
            title: 'Multiple Sites Detected',
            text: 'DO numbers from different sites found. Site filter set to "All".',
            icon: 'info'
          });
        }

        // Send DO numbers to backend for search
        const response = await axios.post(
          'https://pyc99.hslnet.my/api/batching/search/donumbers',
          { doNumbers },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        const result = response.data;
        console.log('Search Results:', result);

        // Update the list with matching records
        if (result.data && result.data.length > 0) {
          setShowList(result.data);
          setSelectedItems([]); 
          setTotalPage(result.totalPages || 1);
          setCurrentPage(1);

          Swal.fire({
            title: 'Success',
            text: `Found ${result.data.length} matching records`,
            icon: 'success'
          });
        } else {
          setShowList([]);
          setSelectedItems([]);
          setTotalPage(1);
          setCurrentPage(1);
          
          Swal.fire({
            title: 'No Matches',
            text: 'No matching records found for the provided DO numbers',
            icon: 'warning'
          });
        }
      } catch (error) {
        console.error('Error processing file:', error);
        setShowList([]);
        setSelectedItems([]);
        setTotalPage(1);
        setCurrentPage(1);
        
        Swal.fire({
          title: 'Error',
          text: error.response?.data || 'Failed to process file',
          icon: 'error'
        });
      }
    };

    reader.readAsArrayBuffer(file);
    // Reset the file input so the same file can be selected again
    event.target.value = '';
  };

  const handleSearchKeywordChange = (e) => {
    const newKeyword = e.target.value;
    setSearchKeyword(newKeyword);
    // Clear all lists and reset pagination when typing in search
    setShowList([]);
    setSelectedItems([]);
    setTotalPage(1);
    setCurrentPage(1);
    // Only fetch new results if there's a keyword
    if (newKeyword) {
      getList();
    }
  };

  return (
    <>
      {access_token ? (
        <>
          <Navbar style={styles.NavbarStyle}>
            <Container fluid>
              <Nav className="w-100 justify-content-between">
                <Nav.Link>
                  <span style={styles.TextStyle}>Sign in as {sv_name}</span>
                </Nav.Link>
                <Nav.Link onClick={handleLogout}>
                  <span style={styles.TextStyle}>Log Out</span>
                </Nav.Link>
              </Nav>
            </Container>
          </Navbar>

          <Container fluid className="ContentResult">
            <Form.Label className="Label">PYC 99</Form.Label>
            <br />

            <div className="d-flex justify-content-between align-items-center mb-3">
              <InputGroup>
                {/* SEARCH */}
                <FormControl
                  className="me-3"
                  placeholder="Search Keyword"
                  value={searchKeyword}
                  onChange={handleSearchKeywordChange}
                  onKeyDown={handleKeyDown}
                />
                {/* PLANT */}
                <InputGroup.Text>Plant</InputGroup.Text>
                <Form.Select
                  className="me-3"
                  value={site}
                  onChange={handleChangePlant}
                >
                  {plantOption.map(({ label, value }, i) => (
                    <option key={i} value={value}>
                      {label}
                    </option>
                  ))}
                </Form.Select>
                {/* FROM DATE */}
                <InputGroup.Text>From</InputGroup.Text>
                <Form.Control
                  name="fromDate"
                  type="date"
                  onChange={handleChangefromDate}
                  value={fromDate}
                />
                {/* TO DATE */}
                <InputGroup.Text>To</InputGroup.Text>
                <Form.Control
                  name="toDate"
                  type="date"
                  onChange={handleChangetoDate}
                  value={toDate}
                />
                <Button
                  className="ButtonSearch me-3"
                  onClick={() => handleClickSearch()}
                >
                  <FontAwesomeIcon icon={faSearch} />
                </Button>
                {/* LIMIT PAGE */}
                <Form.Select
                  className="me-3"
                  value={limitPage}
                  onChange={handleChangeLimitPage}
                >
                  {pageLimitOption.map(({ label, value }, i) => (
                    <option key={i} value={value}>
                      {label}
                    </option>
                  ))}
                </Form.Select>
              </InputGroup>

              <PaginationList
                nPages={totalPage || 1}
                currentPage={currentPage || 1}
                handlePagination={handlePagination}
                // nPages={totalPage}
                // currentPage={currentPage}
                // handlePagination={handlePagination}
              />
            </div>
            
            <div className="d-flex justify-content-end align-items-center gap-2 mb-3">
              <input
                type="file"
                accept=".xlsx,.xls"
                style={{ display: 'none' }}
                onChange={handleFileUpload}
                id="excel-upload"
              />
              <Button 
                variant="success"
                onClick={() => document.getElementById('excel-upload').click()}
              >
                Upload Excel
              </Button>

              {showList.length > 0 && (
                <Button onClick={handlePrint}>Print</Button>
              )}
            </div>
            

            {showList.length > 0 ? (
              <Table responsive>
                <thead style={{ fontSize: "12px" }}>
                  <tr>
                    <th>Print</th>
                    <th>Reviewed</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>D/O No</th>
                    <th>Order No</th>
                    <th>Customer</th>
                    <th>Project</th>
                    <th>Delivery Site</th>
                    <th>Transporter</th>
                    <th>Load Number</th>
                    <th>Progress(m3)</th>
                    <th>Total(m3)</th>
                    <th>Grade</th>
                    <th>Cubic(m3)</th>
                    <th>Slump(mm)</th>
                    <th>Additives</th>
                    <th>Mix Design</th>
                    <th>P/O No</th>
                    <th>Lorry Code</th>
                    <th>Lorry Plate</th>
                    <th>Driver</th>
                    <th>Remark</th>
                    <th>Batched By</th>
                    <th>Review By</th>
                    <th>Reviewed Time</th>
                  </tr>
                </thead>
                <tbody>
                  {showList.map((item, i) => (
                    <tr key={item._id}>
                      <th>
                        <Form.Check
                          type="checkbox"
                          checked={selectedItems.some(selected => selected._id === item._id)}
                          onChange={(e) => handleCheckboxChange(e, item)}
                        />
                      </th>
                      <th>
                        {item.review == 1 ? (
                          <FontAwesomeIcon icon={faCheck} style={{ color: "black" }} />
                        ) : (
                          <Form.Check
                            type="checkbox"
                            checked={item.review == 1}
                            onChange={() => handleTick(item._id)}
                          />
                        )}
                      </th>
                      <th className="ThStyle">{item.data.date}</th>
                      <th className="ThStyle">{item.data.time}</th>
                      <th className="ThStyle">{item.data.do_number}</th>
                      <th className="ThStyle">{item.data.order_no}</th>
                      <th className="ThStyle">{item.data.customer}</th>
                      <th className="ThStyle">{item.data.project}</th>
                      <th className="ThStyle">{item.data.delivery_site}</th>
                      <th className="ThStyle">{item.data.transporter}</th>
                      <th className="ThStyle">{item.data.load_number}</th>
                      <th className="ThStyle">{item.data.progress}</th>
                      <th className="ThStyle">{item.data.total_order}</th>
                      <th className="ThStyle">{item.data.grade}</th>
                      <th className="ThStyle">{item.data.cubic}</th>
                      <th className="ThStyle">{item.data.slump}</th>
                      <th className="ThStyle">{item.data.additives}</th>
                      <th className="ThStyle">{item.data.mix_design}</th>
                      <th className="ThStyle">{item.data.po_no}</th>
                      <th className="ThStyle">{item.data.lorry_code}</th>
                      <th className="ThStyle">{item.data.lorry_plate}</th>
                      <th className="ThStyle">{item.data.driver}</th>
                      <th className="ThStyle">{item.data.remark}</th>
                      <th className="ThStyle">{item.data.batched_by}</th>
                      <th className="ThStyle">{item.reviewed_by}</th>
                      <th className="ThStyle">{item.reviewed_time}</th>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <Table responsive>
                <thead style={{ fontSize: "12px" }}>
                  <tr>
                    <th>Reviewed</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>D/O No</th>
                    <th>Order No</th>
                    <th>Customer</th>
                    <th>Project</th>
                    <th>Delivery Site</th>
                    <th>Transporter</th>
                    <th>Load Number</th>
                    <th>Progress(m3)</th>
                    <th>Total(m3)</th>
                    <th>Grade</th>
                    <th>Cubic(m3)</th>
                    <th>Slump(mm)</th>
                    <th>Additives</th>
                    <th>Mix Design</th>
                    <th>P/O No</th>
                    <th>Lorry Code</th>
                    <th>Lorry Plate</th>
                    <th>Driver</th>
                    <th>Remark</th>
                    <th>Batched By</th>
                    <th>Review By</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className="ThStyle" colSpan={25}>
                      NO DATA. PLEASE SELECT PLANT OR FROM DATE AND TO DATE
                    </th>
                  </tr>
                </tbody>
              </Table>
            )}

            {showList.length > 0 && (
              <div className="d-flex justify-content-between align-items-flex-end mb-3">
                <Button onClick={handleDownloadExcel}>Download Excel</Button>
              </div>
            )}

            <Modal show={showModal} onHide={handleNo}>
              <Modal.Header closeButton>
                <Modal.Title>Confirmation</Modal.Title>
              </Modal.Header>
              <Modal.Body>Confirm to review this item?</Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleNo}>
                  No
                </Button>
                <Button variant="primary" onClick={handleYes}>
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>
          </Container>
        </>
      ) : (
        <LoginPage />
      )}
    </>
  );
};
export default ResultPage;
